<template>
  <div id="WidokSzafa">
    <div id="widok">
      <template v-if="Object.keys(szafa).length>0 && !clearView">
      <div id="KodNazwa">
        <table class="opisTable">
          <tr><td width=80>{{$t('message.kod')}}</td><td align=left>{{szafa.symbol}}</td></tr>
          <tr><td>{{$t('message.nazwa')}}</td><td style="text-align: left;">{{szafa.nazwa}}</td></tr>
        </table>
      </div>
      <div id="ImgAttr" class="row">
        <div id="Img">
          <img :src="urlImagesProduct(szafa.symbol)">
        </div>
        <div id="Attr" class="col-sm kolumna kolumna-2">
          <table id="TabAttr" class="opisTable" style="text-align:left">
            <tr><td>{{$t('message.wymiary')}}:</td><td>{{szafa.szerkosc | decimal}}x{{szafa.wysokosc | decimal}}x{{szafa.glebokosc | decimal}} {{$t('message.mm')}}</td></tr>
            <tr><td>{{$t('message.ilosc_u')}}</td><td>{{szafa.wysokosc_montazowa | decimal}}U</td></tr>
            <tr><td>{{$t('message.waga')}}</td><td>{{Number(szafa.waga)}} {{$t('message.kg')}}</td></tr>
            <tr v-if="$i18n.locale === 'pl'"><td>{{$t('message.cena_detal')}}</td><td><span class='price'>{{Number(szafa.cena)}} {{$t('message.zl')}}</span></td></tr>
            <tr v-if="$i18n.locale === 'pl' && this.inputs.rabatValue > 0"><td style="text-align:right; padding-right:5px">{{$t('message.po_rabacie')}}</td><td><span style="color:red">{{Number(cena_szafy_po_rabacie).toFixed(2)}} {{$t('message.zl')}}</span></td></tr>
            <tr style="height:5px"></tr>
            <tr><td colspan="2">
              <button class="btn" style="color:rgb(59, 163, 255);font-size: 13px;" @click="open((($i18n.locale !== 'pl') ? 'en' : 'pl'),'karta',szafa.symbol)"><img src="../../assets/img/pdf2.svg" width="16"> {{$t('message.karta')}}</button>
            </td></tr>
            <tr><td colspan="2">
              <button class="btn" style="color:rgb(59, 163, 255);font-size: 13px;" @click="open((($i18n.locale !== 'pl') ? 'en' : 'pl'),'instrukcja',szafa.symbol)"><img src="../../assets/img/pdf2.svg" width="16"> {{$t('message.instrukcja')}}</button>
            </td></tr>
          </table>
        </div>
      </div>
      <div id="Desc" v-if="$i18n.locale === 'pl'">
        <p>{{ szafa.paczka_transportu }} </p>
      </div>
      </template>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { app } from '../../mixins/app'

export default {
  name: 'WidokSzafa',
  mixins: [app],
  props: ['szafa', 'clearView'],
  computed: {
    ...mapGetters('app', ['inputs']),
    cena_szafy_po_rabacie () {
      return Number(Number(this.szafa.cena) - Number(this.szafa.cena * (this.inputs.rabatValue / 100)))
    }
  }
}
</script>

<style scoped>
#TabAttr tr td {
  width:145px
}
#widok {
  background: #fff;
  padding: 10px;
  height:230px;
  box-shadow: 2px 2px 2px #ddd;
  /* height: 235px; */
}
#Img {
width: 110px;
padding: 4px 10px;
}
#Img img {
  padding:0px;
  max-height: 110px;
  /* height: 132px; */
}
#Desc {
  text-align: left;
  line-height: 16px;
  font-size: 12px;
}
.price {
  color:white;
  font-weight: bold;
  background: red;
  padding: 2px;
}
.btn {
  line-height: .5;
  padding: 0px;
  line-height: 10px;
}
.btn:focus + .btn, .btn:focus {
    color: #000;
    background-color: none;
    border-color: none;
    box-shadow: none;
}
.btn:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
    box-shadow: none;
}
.opisTable {
  line-height: 16px;
  font-size: 12px;
}
#ImgAttr {
  margin-top:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/View/Szafa.vue